import client from "../config/AxiosConfig";

// Os FAQs vêm agrupados por categoria e já filtrados pelo local do casamento.
export const GetFaqs = async (search = "") =>
  await client.get(`/my-wedding/faqs?search=${encodeURIComponent(search)}`);
